import AddUser from "./add/AddUser";
import EditUser from "./add/EditUser";
import { StatusType } from "components/blocks/status/Status";
import { UserDto } from "api/interfaces/userInterface.interface";
import { ClickSearch } from "components/atoms/input/search/SearchInput";
import { BasePagination } from "api/interfaces/commonInterface.interface";
import { TableColumnsType } from "antd";
import { CommonTable } from "components/atoms/table/AntdTable";

type Props = {
  isAddModal: boolean;
  isEditModal: boolean;
  columns: TableColumnsType<UserDto>;
  data: UserDto[];
  onModal: (type?: string) => void;
  status: StatusType;
  onClickSave: (data: any, update?: boolean) => void;
  selectedUser?: UserDto;
  onChangePage: (page: number, totalRows: number) => void;
  onClickSearch: ClickSearch;
  initialPending: boolean;
  paginationInfo: BasePagination;
  isUpdateLoading: boolean;
  isCreateLoading: boolean;
  onSuccessDelete: () => void;
};

export default function UserListPresenter(props: Props): JSX.Element {
  return (
    <>
      <CommonTable
        columns={props.columns}
        dataSource={props.data}
        queryInfo={props.paginationInfo}
        onChangePage={props.onChangePage}
        loading={props.initialPending}
        rowKey="userId"
      />

      {props.isAddModal && (
        <AddUser
          onModal={() => props.onModal("add")}
          onClickSave={props.onClickSave}
          selectedUser={props.selectedUser}
          isLoading={props.isCreateLoading}
        />
      )}
      {props.isEditModal && props.selectedUser && (
        <EditUser
          onModal={props.onModal}
          onClickSave={props.onClickSave}
          selectedUser={props.selectedUser as UserDto}
          isLoading={props.isUpdateLoading}
          onSuccessDelete={props.onSuccessDelete}
        />
      )}
    </>
  );
}
